import classNames from 'classnames';
import { convertStringToNumber } from '../../utils/ConvertStringToNumber/convertStringToNumber';
import { currentUser } from '../../utils/Auth/auth';
import { userRoles } from '../../constants/enums/User/userRoles';
import { capitalizeString } from '../../utils/StringUtils/capitalizeString';

const AddingUserModal = ({ data, setData = () => {} }) => {
  const countries = [
    { label: 'Canada', value: 'CAN' },
    { label: 'USA', value: 'USA' },
  ];

  const setField = (field, value) => {
    setData((prevData) => ({ ...prevData, [field]: value }));
  };

  const branches = [
    {
      label: 'Toronto, ON, Canada',
      value: '1',
      disabled:
        !currentUser.branches.includes('1') &&
        !currentUser.baseBranch.includes('1'),
    },
    {
      label: 'Port Reading, NJ, USA',
      value: '2',
      disabled:
        !currentUser.branches.includes('2') &&
        !currentUser.baseBranch.includes('2'),
    },
    {
      label: 'California, CA, USA',
      value: '3',
      disabled:
        !currentUser.branches.includes('3') &&
        !currentUser.baseBranch.includes('3'),
    },
    {
      label: 'Chicago, IL, USA',
      value: '4',
      disabled:
        !currentUser.branches.includes('4') &&
        !currentUser.baseBranch.includes('4'),
    },
  ];

  const statusTypes = ['ACTIVE', 'Inactive', 'FRAUD', 'CREATED'];

  const setActivityStatus = (status) => {
    setField('status', status);
  };
  console.log(data?.status);
  return (
    <div className="overflow-y-auto p-4">
      <div className="flex flex-wrap justify-center">
        <div className="text-center w-full font-semibold text-lg">
          Main info
        </div>
        {/* Status */}
        <div className="flex flex-col m-3">
          <span>Status</span>
          <select
            name="status"
            onChange={(e) => setActivityStatus(e.target.value)}
            value={data?.status || ''}
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          >
            <option value="" disabled>
              Select a status...
            </option>
            {statusTypes.map((item) => (
              <option key={`${item}-key`} value={item}>
                {capitalizeString(item)}
              </option>
            ))}
          </select>
        </div>
        {/* Branch Id */}
        <div className="flex flex-col m-3">
          <span>Branch</span>
          <select
            type="text"
            name="branch"
            onChange={(e) =>
              setField('branchId', Number.parseInt(e.target.value))
            }
            value={
              branches.some((item) => item.value === data?.branchId.toString())
                ? data?.branchId.toString()
                : '' || ''
            }
            placeholder="Branch..."
            className={classNames(
              'p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300',
              !branches.some(
                (item) => item.value === data?.branchId.toString(),
              ) && 'text-gray-400',
            )}
          >
            <option className="text-gray-400" value="" disabled>
              Select a branch...
            </option>
            {branches.map((item) => (
              <option
                className={classNames(
                  !item?.disabled ? 'text-gray-600' : 'text-gray-300',
                )}
                disabled={item?.disabled}
                value={item.value.toString()}
                key={item.value}
              >
                {item.label}
              </option>
            ))}
          </select>
        </div>
        {/* CustomerCd */}
        <div className="flex flex-col m-3">
          <span>
            Customer Code<span className="text-red-500 font-bold">{' *'}</span>
          </span>
          <input
            type="text"
            name="customerCd"
            onChange={(e) => setField('customerCd', e.target.value)}
            value={data?.customerCd || ''}
            placeholder="Customer Code..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            maxLength={5}
          />
        </div>

        {/* SubType */}
        {currentUser?.administrators && (
          <div className="flex flex-col m-3">
            <span>Account Type</span>
            <input
              type="text"
              name="subType"
              onChange={(e) => setField('subType', e.target.value)}
              value={data?.subType || ''}
              placeholder="SubType..."
              className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            />
          </div>
        )}

        {/* Role */}
        <div className="flex flex-col m-3">
          <span>Role</span>
          <select
            name="role"
            onChange={(e) => setField('role', e.target.value)}
            value={data?.role || ''}
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          >
            <option value="" disabled>
              Select a role...
            </option>
            {userRoles.map((item) => (
              <option value={item.value} key={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>

        {/* FoxId */}
        <div className="flex flex-col m-3">
          <span>Fox ID</span>
          <input
            type="text"
            name="foxId"
            onChange={(e) =>
              setField('foxId', convertStringToNumber(e.target.value, true))
            }
            value={data?.foxId}
            placeholder="Fox ID..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/*  */}
        <div className="text-center w-full font-semibold text-lg my-5">
          Rate info
        </div>
        {/*  */}

        {/* RateGroup */}
        <div className="flex flex-col m-3">
          <span>Rate Group</span>
          <input
            type="text"
            name="rateGroup"
            onChange={(e) => setField('rateGroup', e.target.value)}
            value={data?.rateGroup || ''}
            placeholder="Rate Group..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* RateGroupMT */}
        <div className="flex flex-col m-3">
          <span>Rate Group{' (Money Transfers)'}</span>
          <input
            type="text"
            name="rateGroupMT"
            onChange={(e) => setField('rateGroupMT', e.target.value)}
            value={data?.rateGroupMT || ''}
            placeholder="Rate Group MT..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/*  */}
        <div className="text-center w-full font-semibold text-lg my-5">
          Personal
        </div>
        {/*  */}

        {/* Email */}
        <div className="flex flex-col m-3">
          <span>
            Email<span className="text-red-500 font-light">{' (unique)*'}</span>
          </span>
          <input
            type="email"
            name="email"
            onChange={(e) => setField('email', e.target.value)}
            value={data?.email || ''}
            placeholder="Email..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* Birthday */}
        <div className="flex flex-col m-3">
          <span>Birthday</span>
          <input
            type="date"
            name="birthday"
            onChange={(e) => setField('birthday', e.target.value)}
            value={data?.birthday || ''}
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* FirstName */}
        <div className="flex flex-col m-3">
          <span>First Name</span>
          <input
            type="text"
            name="firstName"
            onChange={(e) => setField('firstName', e.target.value)}
            value={data?.firstName || ''}
            placeholder="First Name..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            maxLength={20}
          />
        </div>

        {/* LastName */}
        <div className="flex flex-col m-3">
          <span>Last Name</span>
          <input
            type="text"
            name="lastName"
            onChange={(e) => setField('lastName', e.target.value)}
            value={data?.lastName || ''}
            placeholder="Last Name..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
            maxLength={30}
          />
        </div>

        {/* Country */}
        <div className="flex flex-col m-3">
          <span>Country</span>
          <select
            name="country"
            onChange={(e) => setField('country', e.target.value)}
            value={data?.country || ''}
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          >
            <option value="" disabled>
              Select a country...
            </option>
            {countries.map((item) => (
              <option value={item.value} key={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>

        {/* State */}
        <div className="flex flex-col m-3">
          <span>State</span>
          <input
            type="text"
            name="state"
            onChange={(e) => setField('state', e.target.value)}
            value={data?.state || ''}
            placeholder="State..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* Zip */}
        <div className="flex flex-col m-3">
          <span>Zip Code</span>
          <input
            type="text"
            name="zip"
            onChange={(e) => setField('zip', e.target.value)}
            value={data?.zip || ''}
            placeholder="Zip Code..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* City */}
        <div className="flex flex-col m-3">
          <span>City</span>
          <input
            type="text"
            name="city"
            onChange={(e) => setField('city', e.target.value)}
            value={data?.city || ''}
            placeholder="City..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* Apartment */}
        <div className="flex flex-col m-3">
          <span>Apartment</span>
          <input
            maxLength={5}
            type="text"
            name="apartment"
            onChange={(e) => setField('apartment', e.target.value)}
            value={data?.apartment || ''}
            placeholder="Apartment..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* House */}
        <div className="flex flex-col m-3">
          <span>House</span>
          <input
            type="text"
            name="house"
            onChange={(e) => setField('house', e.target.value)}
            value={data?.house || ''}
            placeholder="House..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* Address */}
        <div className="flex flex-col m-3">
          <span>Address</span>
          <input
            maxLength={50}
            type="text"
            name="address"
            onChange={(e) => setField('address', e.target.value)}
            value={data?.address || ''}
            placeholder="Address..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* Phone */}
        <div className="flex flex-col m-3">
          <span>Phone</span>
          <input
            type="text"
            name="phone"
            onChange={(e) => setField('phone', e.target.value)}
            value={data?.phone || ''}
            placeholder="Phone..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* Language */}
        <div className="flex flex-col m-3">
          <span>Language</span>
          <input
            type="text"
            name="language"
            onChange={(e) => setField('language', e.target.value)}
            value={data?.language || ''}
            placeholder="Language..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/*  */}
        <div className="text-center w-full font-semibold text-lg my-5">
          Billing
        </div>
        {/*  */}

        {/* BillingLastName */}
        <div className="flex flex-col m-3">
          <span>Billing Last Name</span>
          <input
            type="text"
            name="billingLastName"
            onChange={(e) => setField('billingLastName', e.target.value)}
            value={data?.billingLastName || ''}
            placeholder="Billing Last Name..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* BillingFirstName */}
        <div className="flex flex-col m-3">
          <span>Billing First Name</span>
          <input
            type="text"
            name="billingFirstName"
            onChange={(e) => setField('billingFirstName', e.target.value)}
            value={data?.billingFirstName || ''}
            placeholder="Billing First Name..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* BillingCountry */}
        <div className="flex flex-col m-3">
          <span>Billing Country</span>
          <select
            name="billingCountry"
            onChange={(e) => setField('billingCountry', e.target.value)}
            value={data?.billingCountry || ''}
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          >
            <option value="" disabled>
              Select a country...
            </option>
            {countries.map((item) => (
              <option value={item.value} key={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        </div>

        {/* BillingZip */}
        <div className="flex flex-col m-3">
          <span>Billing Zip Code</span>
          <input
            type="text"
            name="billingZip"
            onChange={(e) => setField('billingZip', e.target.value)}
            value={data?.billingZip || ''}
            placeholder="Billing Zip Code..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* BillingState */}
        <div className="flex flex-col m-3">
          <span>Billing State</span>
          <input
            type="text"
            name="billingState"
            onChange={(e) => setField('billingState', e.target.value)}
            value={data?.billingState || ''}
            placeholder="Billing State..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* BillingRegion */}
        <div className="flex flex-col m-3">
          <span>Billing Region</span>
          <input
            type="text"
            name="billingRegion"
            onChange={(e) => setField('billingRegion', e.target.value)}
            value={data?.billingRegion || ''}
            placeholder="Billing Region..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* BillingCity */}
        <div className="flex flex-col m-3">
          <span>Billing City</span>
          <input
            type="text"
            name="billingCity"
            onChange={(e) => setField('billingCity', e.target.value)}
            value={data?.billingCity || ''}
            placeholder="Billing City..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* BillingApartment */}
        <div className="flex flex-col m-3">
          <span>Billing Apartment</span>
          <input
            type="text"
            name="billingApartment"
            onChange={(e) => setField('billingApartment', e.target.value)}
            value={data?.billingApartment || ''}
            placeholder="Billing Apartment..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* BillingHouse */}
        <div className="flex flex-col m-3">
          <span>Billing House</span>
          <input
            type="text"
            name="billingHouse"
            onChange={(e) => setField('billingHouse', e.target.value)}
            value={data?.billingHouse || ''}
            placeholder="Billing House..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>

        {/* BillingAddress */}
        <div className="flex flex-col m-3">
          <span>Billing Address</span>
          <input
            type="text"
            name="billingAddress"
            onChange={(e) => setField('billingAddress', e.target.value)}
            value={data?.billingAddress || ''}
            placeholder="Billing Address..."
            className="p-2 border-b-2 border-gray-300 w-48 focus:outline-none mx-2 focus:border-blue-300"
          />
        </div>
      </div>
    </div>
  );
};

export default AddingUserModal;
